var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BeatLoader',{staticStyle:{"margin-top":"1rem","text-align":"center"},attrs:{"loading":_vm.loading,"size":_vm.size,"color":"#1db2d1"}})}
var staticRenderFns = []

export { render, staticRenderFns }